import { Children, isValidElement } from "react";
import { Link } from "react-router-dom";

// 66 books of the Bible — longer names first so "1 John" wins over "John".
const BOOKS = [
  "Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy",
  "Joshua", "Judges", "Ruth",
  "1 Samuel", "2 Samuel", "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles",
  "Ezra", "Nehemiah", "Esther",
  "Job", "Psalms", "Psalm", "Proverbs", "Ecclesiastes", "Song of Solomon", "Song of Songs",
  "Isaiah", "Jeremiah", "Lamentations", "Ezekiel", "Daniel",
  "Hosea", "Joel", "Amos", "Obadiah", "Jonah", "Micah", "Nahum", "Habakkuk",
  "Zephaniah", "Haggai", "Zechariah", "Malachi",
  "Matthew", "Mark", "Luke", "John", "Acts",
  "Romans", "1 Corinthians", "2 Corinthians", "Galatians", "Ephesians",
  "Philippians", "Colossians", "1 Thessalonians", "2 Thessalonians",
  "1 Timothy", "2 Timothy", "Titus", "Philemon",
  "Hebrews", "James", "1 Peter", "2 Peter",
  "1 John", "2 John", "3 John", "Jude", "Revelation",
];

const BOOKS_SORTED = [...BOOKS].sort((a, b) => b.length - a.length);
const BOOK_PATTERN = BOOKS_SORTED.map((b) => b.replace(/\s/g, "\\s")).join("|");
const SCRIPTURE_RE = new RegExp(
  `\\b(${BOOK_PATTERN})\\s(\\d+)(?::(\\d+(?:[-–,\\s\\d]*)?))?\\b`,
  "g"
);

function renderTextWithRefs(text, keyPrefix) {
  if (typeof text !== "string" || !text) return text;
  const parts = [];
  let lastIndex = 0;
  let match;
  const re = new RegExp(SCRIPTURE_RE.source, "g");
  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const refText = match[0];
    parts.push(
      <Link
        key={`${keyPrefix}-${match.index}`}
        to="/bible"
        title={`Open Bible Teachings · ${refText}`}
        className="text-brand-skyDark underline decoration-brand-sky/40 underline-offset-2 hover:text-brand-ink"
      >
        {refText}
      </Link>
    );
    lastIndex = re.lastIndex;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts.length ? parts : text;
}

/**
 * Replace scripture references in direct string children with <Link> components.
 *
 * Important: do NOT recurse into React element children. Each MD_COMPONENTS
 * override that may receive text (p, em, strong, li, blockquote) already calls
 * this helper on its own children, and ReactMarkdown drives the tree walk.
 * Recursing here would double-wrap refs that sit inside <em>/<strong>, which
 * React rejects as a nested-<a> hydration error.
 */
export function linkifyScripture(children, keyPrefix = "scrp") {
  return Children.map(children, (child, idx) => {
    if (typeof child === "string") {
      return renderTextWithRefs(child, `${keyPrefix}-${idx}`);
    }
    if (isValidElement(child)) {
      return child;
    }
    return child;
  });
}
